export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAcCAYAAACgXdXMAAAABHNCSVQICAgIfAhkiAAAABBJREFUCFtj+A8EDIOC8AQAgvhu2+bODN8AAAAASUVORK5CYII="